export default "__VITE_ASSET__UUcWbYjT__"